
import { FilterIconRent } from "../../AssetComponents/Images";

export const FilterHeader = () => {
  return (
    <div className="flex items-center w-full mb-[15px] sm:mb-[20px] gap-1 px-[10px] sm:px-[15px] md:px-[10px] pt-[10px] sm:pt-[15px] md:pt-[10px] filter-header-mobile">
      <FilterIconRent />
      <div className="text-[18px] sm:text-[20px] font-semibold">Filters</div>
    </div>
  );
};